import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiMail, FiPhone } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FiGithub, name: 'GitHub', url: 'https://github.com/asharSQA', color: 'hover:bg-gray-800' },
    { icon: FiLinkedin, name: 'LinkedIn', url: 'https://www.linkedin.com/in/ashar-tariq/', color: 'hover:bg-blue-600' },
    { icon: FiMail, name: 'Email', url: 'mailto:ashar.sqa@gmail.com', color: 'hover:bg-red-500' },
    { icon: FiPhone, name: 'Phone', url: 'tel:+923017022784', color: 'hover:bg-green-500' },
  ];

  const quickLinks = [
    { name: 'Home', to: '/' },
    { name: 'Experience', to: '/experience' },
    { name: 'Skills', to: '/skills' },
    { name: 'Certifications', to: '/certifications' },
    { name: 'Projects', to: '/projects' },
    { name: 'Contact', to: '/contact' },
  ];

  return (
    <footer className="bg-secondary-900 dark:bg-dark-50 text-white transition-colors duration-300">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="py-12">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Brand Section */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-gradient-to-r from-primary-600 to-accent-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">AT</span>
                </div>
                <span className="text-xl font-bold dark:text-white">Ashar Tariq</span>
              </div>
              <p className="text-secondary-300 dark:text-gray-100 mb-6 leading-relaxed">
                SQA Engineer with almost 4 years of expertise in manual and automated testing. Immediately available for new opportunities and open to relocation.
              </p>
              <div className="flex space-x-4 mt-6">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.1 }}
                    className={`w-10 h-10 bg-secondary-800 dark:bg-dark-200 rounded-lg flex items-center justify-center text-secondary-300 dark:text-white hover:text-white dark:hover:text-primary-400 transition-all duration-200 ${social.color}`}
                  >
                    <social.icon className="w-5 h-5" />
                  </motion.a>
                ))}
              </div>
            </div>
            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4 dark:text-white">Quick Links</h3>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.to}
                      className="text-secondary-300 dark:text-white hover:text-primary-400 dark:hover:text-primary-300 transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4 dark:text-white">Contact Info</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-secondary-300 dark:text-white">
                  <span role="img" aria-label="Location">📍</span> Lahore, Pakistan
                </li>
                <li className="flex items-center gap-2 text-secondary-300 dark:text-white">
                  <span role="img" aria-label="Email">📧</span> ashar.sqa@gmail.com
                </li>
                <li className="flex items-center gap-2 text-secondary-300 dark:text-white">
                  <span role="img" aria-label="Phone">📅</span> (+92) 03017022784
                </li>
                <li className="flex items-center gap-2 text-secondary-300 dark:text-white">
                  <span role="img" aria-label="LinkedIn">🔗</span> https://www.linkedin.com/in/ashar-tariq/
                </li>
                <li className="flex items-center gap-2 text-secondary-300 dark:text-white">
                  <span role="img" aria-label="Available">🕒</span> Immediately available for new opportunities
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Divider */}
        <div className="border-t border-secondary-800 dark:border-dark-200"></div>
        {/* Bottom Footer */}
        <div className="py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-secondary-400 dark:text-dark-300 text-sm mb-4 md:mb-0"
            >
              © {currentYear} Ashar Tariq. All rights reserved.
            </motion.p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
